import { createFileRoute } from '@tanstack/react-router';
import { PERMISSION_RIDE_TAG } from '../../Services/PermissionsService';
import { requirePermission } from '../../router/RouteGuardsService';

export const Route = createFileRoute('/_authenticated/system_settings/ride-tag/')({
  beforeLoad: async ({ context }) => {
    await requirePermission(PERMISSION_RIDE_TAG, ['read'], '/unauthorized', context);

    return {
      ...context,
      documentTitle: {
        main: 'tab.ride-tag',
        suffix: 'table.systemSettings',
      },
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: RideTagRoute,
});

function RideTagRoute() {
  return null;
}
